import ApiFetcher3 from '../ApiFetcher3';

class SkillBasedLessonApi {
  static getAllBySkillIds(skillIds, queryParams = {}) {
    const params = {
      skill_ids: skillIds.join(),
      ...queryParams,
    };
    return ApiFetcher3.get('skill-based-lesson/', params);
  }
}

export default SkillBasedLessonApi;
